import React, { createContext, useContext, useState, useEffect } from 'react';

const ManufacturingViewContext = createContext();

export function ManufacturingViewContextProvider({ children }) {
  const [showOnlyManufacturing, setShowOnlyManufacturing] = useState(() => {
    const stored = localStorage.getItem('manufacturingViewShowOnly');
    return stored ? stored === 'true' : true; // Por defecto true (solo pendiente de fabricar)
  });

  // Persistir el estado en localStorage
  useEffect(() => {
    localStorage.setItem('manufacturingViewShowOnly', showOnlyManufacturing.toString());
  }, [showOnlyManufacturing]);

  const toggleView = () => {
    setShowOnlyManufacturing(prev => !prev);
  };

  const value = {
    showOnlyManufacturing,
    toggleView,
    setShowOnlyManufacturing
  };

  return (
    <ManufacturingViewContext.Provider value={value}>
      {children}
    </ManufacturingViewContext.Provider>
  );
}

export function useManufacturingView() {
  const context = useContext(ManufacturingViewContext);
  if (context === undefined) {
    throw new Error('useManufacturingView must be used within a ManufacturingViewContextProvider');
  }
  return context;
} 